import TocquevilleAlexisEmbed from "../images/TocquevilleAlexisEmbed";
import Tocqueville from "../Thumbs/Tocqueville60.jpg";

const TocquevilleAlexis = {
    objectName: 'TocquevilleAlexis',
    firstName: `Alexis de`,
    lastName: 'Tocqueville',
    dates: '1805-1859',
    id: 'AdT1805-1859',
    image: TocquevilleAlexisEmbed,
    thumbImg: Tocqueville,
    quotes: [
    {
        tabHeading: `Alexis de Tocqueville Tyrants quote`,
        metaDescription: `I have always believed that this sort of servitude, regulated, mild and peaceful, of which I have just done the portrait`,
        keywords: ["TrueLibertyNorth", ],
        title: 'Presidents, Kings, Tyrants, & Despots',
        date: '',
        id: 'TdANTLU59',
        headTitle: `Alexis de Tocqueville Tyrants quote`,
        headDescription: `I have always believed that this sort of servitude, regulated, mild and peaceful, of which I have just done the portrait`,
        content: [                  
                {normal: `After having thus taken each individual one by one into its powerful hands, and having molded him as it pleases, the sovereign power extends its arms 
            over the entire society; it covers the surface of society with a network of small, complicated, minute, and uniform rules, which the most original minds and the 
            most vigorous souls cannot break through to go beyond the crowd; it does not break wills, but it softens them, bends them and directs them; it rarely forces action, 
            but it constantly opposes your acting; it does not destroy, it prevents birth; it does not tyrannize, it hinders, it represses, it enervates, it extinguishes, it 
            stupifies, and finally it reduces each nation to being nothing more than a flock of timid and industrious animals, of which the government is the shepherd.`},
              {normal: `I have always believed that this sort of servitude, regulated, mild and peaceful, of which I have just done the portrait, could be combined better 
            than we imagine with some of the external forms of liberty, and that it would not be impossible for it to be established in the very shadow of the sovereignty of 
            the people.`}
        ],
        considerations: [
            {
                name: '',
                title: '',
                date: '',
                content: [``]
            },
            {
                name: '',
                title: '',
                date: '',
                content: [``]
            },
            {
                name: '',
                title: '',
                date: '',
                content: [``]
            }
        ]
    }    
]};

export default TocquevilleAlexis;